import { render, staticRenderFns } from "./workbench-chat.vue?vue&type=template&id=8cc40958&scoped=true&"
import script from "./workbench-chat.vue?vue&type=script&lang=js&"
export * from "./workbench-chat.vue?vue&type=script&lang=js&"
import style0 from "./workbench-chat.vue?vue&type=style&index=0&id=8cc40958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc40958",
  null
  
)

export default component.exports